import * as Colors from 'cfgCommon/colors'

export const SelectStyles = {
    singleValue: (styles, state) => ({
        ...styles,
        color: state.isDisabled ? '#989898' : '#4B4B4B',
        fontWeight: state.hasValue ? 500 : 400,
        whiteSpace: 'nowrap'
    }),
    placeholder: (styles) => ({
        ...styles,
        color: Colors.COLOR_TEXT_EXTRA_LIGHT
    }),
    menu: (styles) => ({
        ...styles,
        boxShadow: 'rgb(51 51 51 / 22%) 0px 4px 8px',
        zIndex: 3, // esto es para que las opciones se supongan por encima de la tabla
    }),
    control: (styles, state) => ({
        ...styles,
        borderColor: state.isFocused ? Colors.COLOR_PRIMARIO : styles.borderColor,
        boxShadow: state.isFocused ? '0 ' + Colors.COLOR_PRIMARIO : styles.boxShadow,
        marginTop: '0',
        minHeight: '0',
        '&:hover': {
            borderColor: state.isFocused ? Colors.COLOR_PRIMARIO : styles['&:hover'].borderColor
        }
    }),
    valueContainer: (styles) => ({
        ...styles,
        minHeight: 30,
        padding: '0 0.375rem'
    }),
    input: (styles) => ({
        ...styles,
        margin: 0
    }),
    indicatorsContainer: (styles) => ({
        ...styles,
        height: '2.25rem'
    }),
    dropdownIndicator: (styles, state) => ({
        ...styles,
        marginRight: '6px',
        color: state.isDisabled ? '#CCCCCC' : '#707070' ,
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null
    }),
    indicatorSeparator: (styles) => ({
        ...styles,
        display: 'none'
    }),
    container: (styles) => ({
        ...styles,
        minHeight: '0'
    }),    
    option: (styles, state) => {
        const backgroundColor = state.isFocused
            ? Colors.COLOR_GRIS_FONDO
            : styles.backgroundColor
        return {
            ...styles,
            borderLeft: 'none',
            backgroundColor: state.isSelected
                ? Colors.COLOR_GRIS_DISABLE_FONDO
                : backgroundColor,
            color: state.isSelected ? Colors.COLOR_TEXT_MEDIUM : styles.color,
            ':active': {
                backgroundColor: backgroundColor,
                color: Colors.COLOR_TEXT_MEDIUM
            },
            ':checked:': {
                backgroundColor: Colors.COLOR_FONDO_HOVER_CLARO
            },
            cursor: state.isFocused ? 'pointer' : 'inherit',
            padding: '0.75rem 1rem',
            minHeight: '2.625rem',
            fontSize: '0.875rem',
            fontStyle: 'normal',
            fontWeight: state.isSelected ? 700 : 600,
        }
    },
}